import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Globe04 = function Globe04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m3.076 7.4828 4.288 3.0629c.2232.1593.3347.239.4515.2574a.5.5 0 0 0 .301-.0466c.1057-.0528.188-.1625.3525-.3818l.9061-1.2082c.0465-.062.0698-.093.0971-.1198a.5.5 0 0 1 .0795-.0633c.0322-.0207.0677-.0364.1385-.068l3.8686-1.7193c.1604-.0713.2405-.107.301-.1626a.5.5 0 0 0 .1234-.1767c.0314-.0759.0372-.1634.0489-.3385l.2833-4.2489M13.5 13.5l2.616 1.1211c.3035.1301.4553.1952.5357.3032a.5.5 0 0 1 .0979.3294c-.0083.1344-.0999.2718-.2831.5465l-1.229 1.8436c-.0868.1302-.1303.1953-.1876.2425a.5.5 0 0 1-.1722.0921c-.071.0216-.1493.0216-.3058.0216h-1.9953c-.2073 0-.311 0-.3992-.0347a.5.5 0 0 1-.2006-.1445c-.0608-.0727-.0936-.1711-.1591-.3678l-.7129-2.1386c-.0387-.1161-.058-.1741-.0631-.233a.5.5 0 0 1 .0111-.1561c.0134-.0576.0407-.1123.0954-.2217l.5415-1.083c.11-.2201.165-.3301.2498-.3984a.5.5 0 0 1 .2604-.1079c.1082-.0116.2249.0273.4583.1051zM22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    })
  }));
};
export default Globe04;